import React, { Component } from "react";
import { Link, NavLink } from 'react-router-dom';
import "./NavBar.css";
import { connect } from 'react-redux';
import { actionCreators } from '../../store/AccountStore';
import { bindActionCreators } from 'redux';

class NavbarHorizontal extends Component {
    constructor(props) {
        super(props);
        this.state = { email: null, name: null, userType: null };
    }
    componentDidMount() {
        this.props.getUser().then(result => {
            if (result) {
                this.setState({
                    email: result.email,
                    name: result.name,
                    userType: result.userType
                });
            }
        })
    }
    toggleFunc() {
        if (this.props.toggleMenu) {
            this.props.handleToggle(false)
        }
        else {
            this.props.handleToggle(true)
        }
    }

    render() {
        return (
            <nav className="navbar-sidebar-horizontal navbar navbar-expand-lg navbar-light bg-dark fixed-top" style={{ marginBottom: 50 }}>
                <a className="navbar-brand" href="#!" style={{ marginTop: "0", marginBottom: "0" }}>
                    <img
                        src="assets/img/minaylalogowhite.png"
                        width="91.5"
                        height="51.8"
                        alt="Minayla"
                    />
                </a>
                <button
                    className={!this.props.toggleMenu ? 'hamburger hamburger--slider' : 'hamburger hamburger--slider is-active'}
                    type="button"
                    data-target=".sidebar-horizontal"
                    aria-controls="sidebar-horizontal"
                    aria-expanded="false"
                    aria-label="Toggle Main Menu"
                    onClick={() => this.toggleFunc()}
                >
                    <span className="hamburger-box">
                        <span className="hamburger-inner" />
                    </span>
                </button>
                <div className="collapse navbar-collapse" id="navbar-header-content" style={{ marginLeft: 30 }}>
                    <ul className="navbar-nav navbar-header-menu mr-auto">
                        {this.state.userType === "FactoringContact" && <li className="nav-item">
                            <NavLink
                                exact
                                activeClassName="active"
                                className="nav-link"
                                to="/factoring"
                            >
                                <i className="batch-icon batch-icon-store" />
                                Factoring
                                </NavLink>
                        </li>}
                        {(this.state.userType === "Broker" || this.state.userType === "CustomerContact") &&
                            <li className="nav-item">
                                <NavLink
                                    exact
                                    activeClassName="active"
                                    className="nav-link"
                                    to="/deliveryorder"
                                >
                                    <i className="batch-icon batch-icon-timeline" />
                                    SHIPMENTS
                                </NavLink>
                            </li>}
     
                        {
                            this.state.userType === "CustomerContact" &&
                            <li className="nav-item">
                                <NavLink
                                    exact
                                    activeClassName="active"
                                    className="nav-link"
                                    to="/accounting"
                                >
                                    <i className="batch-icon batch-icon-paragraph-alt-justify" />
                                    Accounting
                                        </NavLink>
                            </li>
                        }
                        {this.state.userType === "Broker" && <li className="nav-item">
                            <NavLink
                                exact
                                activeClassName="active"
                                className="nav-link"
                                to="/sales"
                            >
                                <i className="batch-icon batch-icon-store" />
                                Sales
                                </NavLink>
                        </li>}

                    </ul>
                    <ul className="navbar-nav ml-5 navbar-profile">
                        <li className="nav-item dropdown">
                            <a
                                href="#!"
                                className="nav-link dropdown-toggle"
                                id="navbar-dropdown-navbar-profile"
                                data-toggle="dropdown"
                                data-flip="false"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <div className="profile-name">{this.state.name}</div>
                                <div className="profile-picture bg-gradient bg-primary has-message float-right">

                                </div>
                            </a>
                            <ul
                                className="dropdown-menu dropdown-menu-right"
                                aria-labelledby="navbar-dropdown-navbar-profile"
                            >
                                <li>
                                    <NavLink
                                        exact
                                        activeClassName="active"
                                        className="nav-link"
                                        to="/Profile"
                                    >
                                        <i className="batch-icon batch-icon-user" />
                                        Profile
                                </NavLink>
                                </li>
                                <li>
                                    {
                                        this.state.userType === "FactoringContact" || this.state.userType === "Broker" ? null : <Link to="/mycards" className="dropdown-item"><i className="batch-icon batch-icon-credit-card-alt" /> My Cards </Link>
                                    }

                                </li>
                                <li>
                                    <Link to="/login" className="dropdown-item"><i className="batch-icon batch-icon-power" /> Logout</Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}

export default connect(
    state => state.account,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(NavbarHorizontal);



// WEBPACK FOOTER //
// ./src/layout/NavBar/NavbarHorizontal.jsx